export default {
  findQueueslist: { method: "get", url: "guiche" },
  deleteQueue: { method: "delete", url: "guiche/delete{/id}" },
};
